import { useQuery } from "@tanstack/react-query";
import {
  agentToolsApi,
  type MCPConnectionTool,
} from "../../../services/agent-tools-service";
import { MCP_CONNECTIONS_QUERY_KEY } from "./useMCPConnections";

export const MCP_TOOLS_QUERY_KEY = [
  ...MCP_CONNECTIONS_QUERY_KEY,
  "tools",
] as const;

type UseMCPToolsResult = {
  tools: MCPConnectionTool[];
  isLoading: boolean;
  error: Error | null;
};

export const useMCPTools = (id: string | null): UseMCPToolsResult => {
  const query = useQuery({
    queryKey: [...MCP_TOOLS_QUERY_KEY, id],
    queryFn: () => agentToolsApi.listMCPTools(id as string),
    enabled: Boolean(id),
    staleTime: 30_000,
  });

  return {
    tools: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error as Error | null,
  };
};
